export const calcPercentForVideo = (height, width) => {
  const percent = (height / width) * 100;
  return Math.min(56.25, percent);
};
